(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8906],{

/***/ 66197:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/[[...slug]]",
      function () {
        return __webpack_require__(51560);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _api_queries_entries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78721);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_core_Collections_useEntries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60649);
/* harmony import */ var _mosanic_core_Page_Render__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26381);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _redux_auth_action__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64157);
/* harmony import */ var _mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73987);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);













var useRetrieveEntry = function(filterEntry) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_6__/* .useLazyQuery */ .td)("entryMany", _api_queries_entries__WEBPACK_IMPORTED_MODULE_7__/* .FILTER_ENTRIES */ .r8, null), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref[1], 3), entries = ref1[0], loadingCollection = ref1[1], errorCollection = ref1[2];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((filterEntry === null || filterEntry === void 0 ? void 0 : filterEntry.collectionId) && (filterEntry === null || filterEntry === void 0 ? void 0 : filterEntry.slug)) handler(filterEntry ? {
            filter: filterEntry
        } : null);
    }, [
        filterEntry === null || filterEntry === void 0 ? void 0 : filterEntry.collectionId,
        filterEntry === null || filterEntry === void 0 ? void 0 : filterEntry.slug
    ]);
    // const entries = await client.query('entryMany', ENTRIES_SLUG, {filter: filterEntry} )
    // const fullEntry = await client.query('entryById', ENTRY, {_id: entries?.[0]?._id} )
    // const  [handlerEntry, [fullEntry]] = useEntry({_id: entries?.[0]?._id})
    // return entries
    return (0,_mosanic_core_Collections_useEntries__WEBPACK_IMPORTED_MODULE_8__/* .convertEntry */ .ec)(entries === null || entries === void 0 ? void 0 : entries[0]);
};
var __N_SSG = true;
function Index(param) {
    var data = param.data, entry = param.entry, page = param.page, header = param.header, footer = param.footer;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    header = header ? JSON.parse(header) : null;
    footer = footer ? JSON.parse(footer) : null;
    page = page ? JSON.parse(page) : null;
    data = data ? JSON.parse(data) : null;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data._id) dispatch((0,_redux_auth_action__WEBPACK_IMPORTED_MODULE_9__/* .setSiteId */ .Or)({
            siteId: data === null || data === void 0 ? void 0 : data._id
        }));
    }, [
        data === null || data === void 0 ? void 0 : data._id,
        dispatch
    ]);
    // collection = collection ? JSON.parse(collection) : null;
    entry = entry ? JSON.parse(entry) : null;
    var fullEntry = useRetrieveEntry(entry === null || entry === void 0 ? void 0 : entry.retrieve);
    if (fullEntry) entry = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, entry, fullEntry);
    var favicon = (data === null || data === void 0 ? void 0 : (ref = data.logo) === null || ref === void 0 ? void 0 : (ref1 = ref.favicon) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.img) === null || ref2 === void 0 ? void 0 : ref2.url) || null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            favicon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "icon",
                    href: (ref3 = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_11__/* .parseImageSrc */ .yO)(favicon, true)) === null || ref3 === void 0 ? void 0 : ref3.thumb
                })
            }),
            (data === null || data === void 0 ? void 0 : (ref4 = data.code) === null || ref4 === void 0 ? void 0 : ref4.header) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: data === null || data === void 0 ? void 0 : (ref5 = data.code) === null || ref5 === void 0 ? void 0 : ref5.header
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_core_Page_Render__WEBPACK_IMPORTED_MODULE_12__/* .PageRender */ .XP, {
                page: page,
                seo: page === null || page === void 0 ? void 0 : page.seo,
                locale: locale,
                entry: entry,
                headerPage: header,
                footerPage: footer,
                site: data
            }),
            (data === null || data === void 0 ? void 0 : (ref6 = data.code) === null || ref6 === void 0 ? void 0 : ref6.footer) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: data === null || data === void 0 ? void 0 : (ref7 = data.code) === null || ref7 === void 0 ? void 0 : ref7.footer
                }
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(66197); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);